// extracted by mini-css-extract-plugin
export default {"customerBenefitsContainer":"CustomerBenefitsWithBadges_customerBenefitsContainer__JqEtb","serviceBenefits":"CustomerBenefitsWithBadges_serviceBenefits__vsFBk"};